/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class BackgroundJobQueryCounterPerCaller {
    getFixupPrototypeFunction() { return BackgroundJobQueryCounterPerCaller.fixupPrototype; }

    static newInstance(model: Partial<BackgroundJobQueryCounterPerCaller>): BackgroundJobQueryCounterPerCaller {
        let obj = Object.assign(new BackgroundJobQueryCounterPerCaller(), model);
        BackgroundJobQueryCounterPerCaller.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<BackgroundJobQueryCounterPerCaller>): BackgroundJobQueryCounterPerCaller {
        if (!model) return null;
        return BackgroundJobQueryCounterPerCaller.newInstance(<BackgroundJobQueryCounterPerCaller> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: BackgroundJobQueryCounterPerCaller) {
        if (!obj) return;

        models.BackgroundJobQueryCounterPerCaller.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: BackgroundJobQueryCounterPerCaller): boolean {
        Object.setPrototypeOf(obj, BackgroundJobQueryCounterPerCaller.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.hits === undefined) {
            this.hits = 0;
        }
        if (this.execution_time === undefined) {
            this.execution_time = 0;
        }
        if (this.frames) {
            for (let val of this.frames) {
                models.BackgroundJobThreadFrame.fixupPrototype(val);
            }
        }
    }

    /**
     * Stack frames for the thread
     */
    frames: Array<models.BackgroundJobThreadFrame>;

    /**
     * Total number of calls
     */
    hits: number;

    /**
     * Total execution time in seconds
     */
    execution_time: number;

}
